<template>
  <div id="app" >
  <!-- <div class="snow"></div> -->
    <router-view />

    <div v-if="showCookieBanner" class="cookie-banner">
      <p class="cookie-banner__text">
        {{ cookieMessage }}
      </p>
      <button class="cookie-banner__button" @click="acceptCookies">
        {{ acceptLabel }}
      </button>
    </div>
  </div>
</template>

<script>
import { getCookie, setCookie, getPersistentItem } from "@/utils/cookies";

export default {
  data() {
    return {
      showCookieBanner: false,
    };
  },
  computed: {
    currentLang() {
      return this.$i18n?.locale || getPersistentItem("lang") || "ar";
    },
    cookieMessage() {
      if (this.currentLang === "en") {
        return "We use cookies to improve your browsing experience. Please accept cookies to continue.";
      }

      return "نستخدم ملفات تعريف الارتباط لتحسين تجربة التصفح. يرجى قبول ملفات تعريف الارتباط للمتابعة.";
    },
    acceptLabel() {
      return this.currentLang === "en" ? "Accept Cookies" : "قبول ملفات الارتباط";
    },
  },
  mounted() {
    this.showCookieBanner = !getCookie("cookie_consent");

    if (!this.showCookieBanner) {
      this.loadChatbot();
    }
  },
  methods: {
    acceptCookies() {
      setCookie("cookie_consent", "accepted", 365);
      this.showCookieBanner = false;
      this.loadChatbot();
    },
    loadChatbot() {
      if (document.getElementById("openwidget-script")) {
        return;
      }

      window.__ow = window.__ow || {};
      window.__ow.organizationId = "1e47b99c-7b7f-4b52-965b-ba6195573f78";
      window.__ow.template_id = "05473b54-472e-4569-80e0-ea7330f346f0";
      window.__ow.integration_name = "manual_settings";
      window.__ow.product_name = "chatbot";

      const script = document.createElement("script");
      script.id = "openwidget-script";
      script.async = true;
      script.type = "text/javascript";
      script.src = "https://cdn.openwidget.com/openwidget.js";
      document.head.appendChild(script);
    },
  },
};
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 16px;
  background: #0f2a44;
  color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.28);
}

.cookie-banner__text {
  margin: 0;
  font-size: 14px;
  line-height: 1.5;
}

.cookie-banner__button {
  border: 0;
  background: #f5c451;
  color: #14233b;
  font-weight: 700;
  padding: 9px 14px;
  border-radius: 8px;
  cursor: pointer;
  white-space: nowrap;
}

@media (max-width: 768px) {
  .cookie-banner {
    flex-direction: column;
    align-items: stretch;
  }

  .cookie-banner__button {
    width: 100%;
  }
}
</style>
